import React, { useState } from "react";
import classNames from "classnames";
import { GridCol } from "@design-system/Grid/GridCol";
import { GridRow } from "@design-system/Grid/GridRow";
import { SelectControl, VariantGrid, VariantItem } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./structureLayoutControls.module.scss";

const spanOptions = ["3", "4", "6", "8", "9", "12"] as const;
type SpanOption = (typeof spanOptions)[number];

const spans: Record<SpanOption, number> = {
    "3": 3,
    "4": 4,
    "6": 6,
    "8": 8,
    "9": 9,
    "12": 12,
};

export const GridPlayground = () => {
    const [firstSpan, setFirstSpan] = useState<SpanOption>("4");
    const [secondSpan, setSecondSpan] = useState<SpanOption>("8");

    return (
        <SandboxLayout
            controls={
                <section>
                    <h2>Column spans</h2>
                    <div className={styles.fields}>
                        <SelectControl
                            label="First column"
                            options={spanOptions}
                            value={firstSpan}
                            onChange={setFirstSpan}
                        />
                        <SelectControl
                            label="Second column"
                            options={spanOptions}
                            value={secondSpan}
                            onChange={setSecondSpan}
                        />
                    </div>
                </section>
            }
        >
            <ShowcasePreview
                summary={`${firstSpan} + ${secondSpan} columns`}
                alignment="start"
                width="full"
                output={JSON.stringify(
                    {
                        componentProps: {
                            firstColumn: { sm: spans[firstSpan] },
                            secondColumn: { sm: spans[secondSpan] },
                        },
                        showcaseState: {},
                    },
                    null,
                    2,
                )}
            >
                <VariantGrid
                    title="Responsive grid with nesting"
                    columns="full"
                >
                    <VariantItem
                        label={`GridCol sm={${firstSpan}} + sm={${secondSpan}}`}
                    >
                        <GridRow gap="16px">
                            <GridCol sm={spans[firstSpan]}>
                                <div
                                    className={classNames(
                                        styles.layoutBox,
                                        styles.gridBox,
                                    )}
                                >
                                    Span {firstSpan}
                                </div>
                            </GridCol>
                            <GridCol sm={spans[secondSpan]}>
                                <div className={styles.nestedGrid}>
                                    <GridRow gap="8px">
                                        <GridCol sm={6}>
                                            <div className={styles.layoutBox}>
                                                Nested 6
                                            </div>
                                        </GridCol>
                                        <GridCol sm={6}>
                                            <div className={styles.layoutBox}>
                                                Nested 6
                                            </div>
                                        </GridCol>
                                    </GridRow>
                                </div>
                            </GridCol>
                        </GridRow>
                    </VariantItem>
                </VariantGrid>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
